import { useAuth } from '@modules/auth/hooks';
import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { STUDY_INSIGHTS_DEMOGRAPHICS_QUERY_KEY } from '../constants';
import { fetchDemographicsV2 } from '../services/demographics.service';
import { DemographicsParam, DemographicsResponse, DemographicsSerieStatus } from '../types';

const useQueryDemographics = <TError = unknown>(
  params: DemographicsParam,
  options?: Omit<
    UseQueryOptions<
      DemographicsResponse | undefined,
      TError,
      DemographicsResponse,
      Array<string | DemographicsSerieStatus[] | (string | undefined)>
    >,
    'initialData' | 'queryFn' | 'queryKey'
  >,
): UseQueryResult<DemographicsResponse> => {
  const { isAuthenticated } = useAuth();

  const enabledOption = options?.enabled !== undefined ? !!options?.enabled : true;
  return useQuery(
    [STUDY_INSIGHTS_DEMOGRAPHICS_QUERY_KEY, params.sampleStatus, params.startDate, params.endDate],
    async () => await fetchDemographicsV2(params),
    {
      ...options,
      enabled: isAuthenticated === true && enabledOption,
    },
  );
};

export default useQueryDemographics;
